'use client'

import Link from 'next/link'
import { useSearchParams } from 'next/navigation'
import type { ReactNode } from 'react'
import styles from './BackofficeCrumb.module.scss'

interface BackofficeCrumbProps {
	readonly href: string
	readonly label?: string
	readonly icon?: ReactNode
}

export const BackofficeCrumb = ({
	href,
	label,
	icon,
}: BackofficeCrumbProps) => {
	const searchParams = useSearchParams()
	const params = searchParams ? `?${searchParams.toString()}` : ''

	return (
		<Link
			data-testid='breadcrumb.link'
			className={styles.breadcrumbLink}
			href={`${href}${params}`}
		>
			{icon}
			{label}
		</Link>
	)
}
